import React from 'react';
import { DotsSVG } from '../../@common_components/svgs/dots.svg';

const DotsIcon: React.FC<React.SVGProps<SVGSVGElement>> = props => {
  return <DotsSVG {...props} />;
};

export { DotsIcon };
